import "./PromoCard.css";

const PromoCard = ({ data }) => {
  const { bannerTitle, bannerImage, bannerButtonLabel, bannerBackgroundColor } =
    data;
  return (
    <div className="promo-card">
      <div
        className="promo-card-content"
        style={{ backgroundColor: bannerBackgroundColor }}
      >
        <div
          className="promo-text"
          style={{ backgroundColor: bannerBackgroundColor }}
        >
          <h5 className="text-white mb-3">{bannerTitle}</h5>
          <span
            className="btn btn-light fw-bold w-fit d-inline-block promo-static-btn"
            aria-disabled="true"
          >
            {bannerButtonLabel}
          </span>
        </div>
        <div className="promo-image-container">
          <img src={bannerImage} alt="Promo" className="promo-image" />
        </div>
      </div>
    </div>
  );
};

export default PromoCard;
